import React from "react";
import { ListRow } from "../../organisms";
import "react-responsive-modal/styles.css";

const ProductsList = ({
  productTitle,
  productName,
  image,
  quantity,
  value,
  onClick,
  isImage,
  onOpenModal,
  isActive,
  isTopDeal,
  isTopDealTcsFunded
}) => {
  return (
    <div className="hoverStateRow">
      <ListRow
        title={productTitle}
        productName={productName}
        image={image}
        quantity={quantity}
        value={value}
        onClick={onClick}
        isImage={isImage}
        onOpenModal={onOpenModal}
        isActive={isActive}
        isTopDeal={isTopDeal}
        isTopDealTcsFunded={isTopDealTcsFunded}
      />
    </div>
  );
};

export default ProductsList;
